<template>
  <form>
    <div class="row">
      <div class="col-lg-12">
        <div class="row">
          <div class="col-lg-9">
            <h4 class="card-title font-weight-bold">{{$t('medium_grant_ev.technical__evaluation_form')}}</h4>
            <h5 class="card-title font-weight-bold mt-5">{{$t('medium_grant_ev.technical__technical_1_title')}}</h5>
            <p class="white-space-pre-line">{{$t('medium_grant_ev.technical__technical_1_title_sub')}}</p>
          </div>
          <div class="col-lg-3">
            <info-right></info-right>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <table class="table-bordered table-full-width mt-3" cellpadding="20">
              <tr>
                <th width="40%">{{$t('medium_grant_ev.technical__technical_criteria')}}</th>
                <th width="10%">{{$t('medium_grant_ev.technical__technical_max_score')}}</th>
                <th width="10%" style="min-width: 150px;">{{$t('medium_grant_ev.technical__technical_awarded_score')}}</th>
                <th width="20%">{{$t('medium_grant_ev.technical__technical_comments')}}</th>
                <th width="10%">{{$t('medium_grant_ev.technical__technical_final_score')}}</th>
              </tr>
              <tr>
                <td class="border-bottom-0">
                  <p>
                    {{$t('medium_grant_ev.technical__criteria_1_1')}}
                  </p>
                </td>
                <td class="border-top-0 border-bottom-0"></td>
                <td class="border-bottom-0"></td>
                <td class="border-bottom-0"></td>
                <td class="border-bottom-0"></td>
              </tr>
              <tr>
                <td class="border-top-0 border-bottom-0">
                  <base-checkbox name="checkbox" v-model="EvaluationForm.model.quantified_mangament">
                    {{$t('medium_grant_ev.technical__criteria_1_1_quantified')}}
                  </base-checkbox>
                </td>
                <td class="border-top-0 border-bottom-0">
                  {{$t('medium_grant_ev.technical__criteria_1_1_quantified_max')}}
                </td>
                <td class="border-top-0 border-bottom-0">
                  <el-select class="filter-select mr-2" v-model="EvaluationForm.model.awarded_quantified" placeholder="Score">
                    <el-option v-for="item in 11" :key="item-1" :label="item-1" :value="item-1"/>
                  </el-select>
                </td>
                <td class="border-bottom-0 border-top-0">
                  <base-input>
      <textarea
        class="form-control mt-5"
        :placeholder="$t('general.write_here')"
        v-model="EvaluationForm.model.comments_quantified"
      >
      </textarea>
                  </base-input>
                </td>
                <td class="border-bottom-0 border-top-0"></td>
              </tr>
              <tr>
                <td class="border-top-0 border-bottom-0">
                  <base-checkbox name="checkbox" v-model="EvaluationForm.model.strategic_doc">
                    {{$t('medium_grant_ev.technical__criteria_1_1_strategic')}}
                  </base-checkbox>
                </td>
                <td rowspan="2" class="border-top-0">
                  {{$t('medium_grant_ev.technical__criteria_1_1_studies_max')}}
                </td>
                <td rowspan="2" class="border-top-0">
                  <el-select class="filter-select mr-2" v-model="EvaluationForm.model.awarded_strategic" placeholder="Score">
                    <el-option v-for="item in 6" :key="item-1" :label="item-1" :value="item-1"/>
                  </el-select>
                </td>
                <td class="border-bottom-0 border-top-0">
                  <base-input>
      <textarea
        class="form-control mt-5"
        :placeholder="$t('general.write_here')"
        v-model="EvaluationForm.model.comments_strategic"
      >
      </textarea>
                  </base-input>
                </td>
                <td class="border-bottom-0 border-top-0"></td>
              </tr>
              <tr>
                <td class="border-top-0">
                  <base-checkbox name="checkbox" v-model="EvaluationForm.model.studies_validated">
                    {{$t('medium_grant_ev.technical__criteria_1_1_studies')}}
                  </base-checkbox>
                  <div class="mt-3">
                    <label>{{$t('medium_grant_ev.technical__criteria_1_1_studies_sub')}}</label>
                  </div>
                </td>
                <td class="border-top-0"></td>
                <td class="border-top-0"></td>
              </tr>

              <tr>
                <td>
                  <p class="white-space-pre-line">
                    {{$t('medium_grant_ev.technical__criteria_1_2')}}
                  </p>
                </td>
                <td>
                  {{$t('medium_grant_ev.technical__criteria_1_2_max')}}
                </td>
                <td>
                  <el-select class="filter-select mr-2" v-model="EvaluationForm.model.criteria_one_two" placeholder="Score">
                    <el-option v-for="item in 11" :key="item-1" :label="item-1" :value="item-1"/>
                  </el-select>
                </td>
                <td>
                  <base-input>
      <textarea
        class="form-control mt-5"
        :placeholder="$t('general.write_here')"
        v-model="EvaluationForm.model.comments_critieria_one_two"
      >
      </textarea>
                  </base-input>
                </td>
                <td></td>
              </tr>

              <tr>
                <td>
                  <p class="white-space-pre-line">
                    {{$t('medium_grant_ev.technical__criteria_1_3')}}
                  </p>
                </td>
                <td>
                  {{$t('medium_grant_ev.technical__criteria_1_3_max')}}
                </td>
                <td>
                  <el-select class="filter-select mr-2" v-model="EvaluationForm.model.criteria_one_three" placeholder="Score">
                    <el-option v-for="item in 6" :key="item-1" :label="item-1" :value="item-1"/>
                  </el-select>
                </td>
                <td>
                  <base-input>
      <textarea
        class="form-control mt-5"
        :placeholder="$t('general.write_here')"
        v-model="EvaluationForm.model.comments_critieria_one_three"
      >
      </textarea>
                  </base-input>
                </td>
                <td></td>
              </tr>

              <tr>
                <td>
                  <p class="white-space-pre-line">
                    {{$t('medium_grant_ev.technical__criteria_1_4')}}
                  </p>
                </td>
                <td>
                  {{$t('medium_grant_ev.technical__criteria_1_4_max')}}
                </td>
                <td>
                  <el-select class="filter-select mr-2" v-model="EvaluationForm.model.criteria_one_four" placeholder="Score">
                    <el-option v-for="item in 6" :key="item-1" :label="item-1" :value="item-1"/>
                  </el-select>
                </td>
                <td>
                  <base-input>
      <textarea
        class="form-control mt-5"
        :placeholder="$t('general.write_here')"
        v-model="EvaluationForm.model.comments_critieria_one_four"
      >
      </textarea>
                  </base-input>
                </td>
                <td></td>
              </tr>

              <tr>
                <td>
                  <p class="white-space-pre-line">
                    {{$t('medium_grant_ev.technical__criteria_1_5')}}
                  </p>
                </td>
                <td>
                  {{$t('medium_grant_ev.technical__criteria_1_5_max')}}
                </td>
                <td>
                  <el-select class="filter-select mr-2" v-model="EvaluationForm.model.criteria_one_five" placeholder="Score">
                    <el-option v-for="item in 6" :key="item-1" :label="item-1" :value="item-1"/>
                  </el-select>
                </td>
                <td>
                  <base-input>
      <textarea
        class="form-control mt-5"
        :placeholder="$t('general.write_here')"
        v-model="EvaluationForm.model.comments_critieria_one_five"
      >
      </textarea>
                  </base-input>
                </td>
                <td></td>
              </tr>

              <tr>
                <td>
                  <p class="white-space-pre-line">
                    {{$t('medium_grant_ev.technical__criteria_1_6')}}
                  </p>
                </td>
                <td>
                  {{$t('medium_grant_ev.technical__criteria_1_6_max')}}
                </td>
                <td>
                  <el-select class="filter-select mr-2" v-model="EvaluationForm.model.criteria_one_six" placeholder="Score">
                    <el-option v-for="item in 11" :key="item-1" :label="item-1" :value="item-1"/>
                  </el-select>
                </td>
                <td>
                  <base-input>
      <textarea
        class="form-control mt-5"
        :placeholder="$t('general.write_here')"
        v-model="EvaluationForm.model.comments_critieria_one_six"
      >
      </textarea>
                  </base-input>
                </td>
                <td></td>
              </tr>

              <tr>
                <td>
                  <p class="white-space-pre-line">
                    {{$t('medium_grant_ev.technical__criteria_1_7')}}
                  </p>
                </td>
                <td>
                  {{$t('medium_grant_ev.technical__criteria_1_7_max')}}
                </td>
                <td>
                  <el-select class="filter-select mr-2" v-model="EvaluationForm.model.criteria_one_seven" placeholder="Score">
                    <el-option v-for="item in 6" :key="item-1" :label="item-1" :value="item-1"/>
                  </el-select>
                </td>
                <td>
                  <base-input>
      <textarea
        class="form-control mt-5"
        :placeholder="$t('general.write_here')"
        v-model="EvaluationForm.model.comments_critieria_one_seven"
      >
      </textarea>
                  </base-input>
                </td>
                <td></td>
              </tr>

              <tr>
                <td>
                  <p class="white-space-pre-line">
                    {{$t('medium_grant_ev.technical__criteria_1_8')}}
                  </p>
                </td>
                <td>
                  {{$t('medium_grant_ev.technical__criteria_1_8_max')}}
                </td>
                <td>
                  <el-select class="filter-select mr-2" v-model="EvaluationForm.model.criteria_one_eight" placeholder="Score">
                    <el-option v-for="item in 6" :key="item-1" :label="item-1" :value="item-1"/>
                  </el-select>
                </td>
                <td>
                  <base-input>
      <textarea
        class="form-control mt-5"
        :placeholder="$t('general.write_here')"
        v-model="EvaluationForm.model.comments_critieria_one_eight"
      >
      </textarea>
                  </base-input>
                </td>
                <td></td>
              </tr>

              <tr>
                <td colspan="5">
                  <h5 class="card-title font-weight-bold">{{$t('medium_grant_ev.technical__criteria_2_sub')}}</h5>
                  <p class="white-space-pre-line">
                    {{$t('medium_grant_ev.technical__criteria_2')}}
                  </p>
                </td>
              </tr>

              <tr>
                <td>
                  <p class="white-space-pre-line">
                    {{$t('medium_grant_ev.technical__criteria_2_1')}}
                  </p>
                </td>
                <td>
                  {{$t('medium_grant_ev.technical__criteria_2_1_max')}}
                </td>
                <td>
                  <el-select class="filter-select mr-2" v-model="EvaluationForm.model.criteria_two_one" placeholder="Score">
                    <el-option v-for="item in 6" :key="item-1" :label="item-1" :value="item-1"/>
                  </el-select>
                </td>
                <td>
                  <base-input>
      <textarea
        class="form-control mt-5"
        :placeholder="$t('general.write_here')"
        v-model="EvaluationForm.model.comments_critieria_two_one"
      >
      </textarea>
                  </base-input>
                </td>
                <td></td>
              </tr>

              <tr>
                <td>
                  <p class="white-space-pre-line">
                    {{$t('medium_grant_ev.technical__criteria_2_2')}}
                  </p>
                </td>
                <td>
                  {{$t('medium_grant_ev.technical__criteria_2_2_max')}}
                </td>
                <td>
                  <el-select class="filter-select mr-2" v-model="EvaluationForm.model.criteria_two_two" placeholder="Score">
                    <el-option v-for="item in 6" :key="item-1" :label="item-1" :value="item-1"/>
                  </el-select>
                </td>
                <td>
                  <base-input>
      <textarea
        class="form-control mt-5"
        :placeholder="$t('general.write_here')"
        v-model="EvaluationForm.model.comments_critieria_two_two"
      >
      </textarea>
                  </base-input>
                </td>
                <td></td>
              </tr>

              <tr>
                <td>
                  <p class="white-space-pre-line">
                    {{$t('medium_grant_ev.technical__criteria_2_3')}}
                  </p>
                </td>
                <td>
                  {{$t('medium_grant_ev.technical__criteria_2_3_max')}}
                </td>
                <td>
                  <el-select class="filter-select mr-2" v-model="EvaluationForm.model.criteria_two_three" placeholder="Score">
                    <el-option v-for="item in 11" :key="item-1" :label="item-1" :value="item-1"/>
                  </el-select>
                </td>
                <td>
                  <base-input>
      <textarea
        class="form-control mt-5"
        :placeholder="$t('general.write_here')"
        v-model="EvaluationForm.model.comments_critieria_two_three"
      >
      </textarea>
                  </base-input>
                </td>
                <td></td>
              </tr>

              <tr>
                <td colspan="5">
                  <h5 class="card-title font-weight-bold">{{$t('medium_grant_ev.technical__criteria_3')}}</h5>
                  <p class="white-space-pre-line">
                    {{$t('medium_grant_ev.technical__criteria_3_sub')}}
                  </p>
                </td>
              </tr>

              <tr>
                <td>
                  <p class="white-space-pre-line">
                    {{$t('medium_grant_ev.technical__criteria_3_1')}}
                  </p>
                </td>
                <td>
                  {{$t('medium_grant_ev.technical__criteria_3_1_max')}}
                </td>
                <td>
                  <el-select class="filter-select mr-2" v-model="EvaluationForm.model.criteria_three_one" placeholder="Score">
                    <el-option v-for="item in 6" :key="item-1" :label="item-1" :value="item-1"/>
                  </el-select>
                </td>
                <td>
                  <base-input>
      <textarea
        class="form-control mt-5"
        :placeholder="$t('general.write_here')"
        v-model="EvaluationForm.model.comments_critieria_three_one"
      >
      </textarea>
                  </base-input>
                </td>
                <td></td>
              </tr>

              <tr>
                <td>
                  <p class="white-space-pre-line">
                    {{$t('medium_grant_ev.technical__criteria_3_2')}}
                  </p>
                </td>
                <td>
                  {{$t('medium_grant_ev.technical__criteria_3_2_max')}}
                </td>
                <td>
                  <el-select class="filter-select mr-2" v-model="EvaluationForm.model.criteria_three_two" placeholder="Score">
                    <el-option v-for="item in 6" :key="item-1" :label="item-1" :value="item-1"/>
                  </el-select>
                </td>
                <td>
                  <base-input>
      <textarea
        class="form-control mt-5"
        :placeholder="$t('general.write_here')"
        v-model="EvaluationForm.model.comments_critieria_three_two"
      >
      </textarea>
                  </base-input>
                </td>
                <td></td>
              </tr>

              <tr>
                <td colspan="5">
                  <h5 class="card-title font-weight-bold">{{$t('medium_grant_ev.technical__criteria_4')}}</h5>
                  <p class="white-space-pre-line">
                    {{$t('medium_grant_ev.technical__criteria_4_sub')}}
                  </p>
                </td>
              </tr>

              <tr>
                <td>
                  <p class="white-space-pre-line">
                    {{$t('medium_grant_ev.technical__criteria_4_1')}}
                  </p>
                </td>
                <td>
                  {{$t('medium_grant_ev.technical__criteria_4_1_max')}}
                </td>
                <td>
                  <el-select class="filter-select mr-2" v-model="EvaluationForm.model.criteria_four_one" placeholder="Score">
                    <el-option v-for="item in 11" :key="item-1" :label="item-1" :value="item-1"/>
                  </el-select>
                </td>
                <td>
                  <base-input>
      <textarea
        class="form-control mt-5"
        :placeholder="$t('general.write_here')"
        v-model="EvaluationForm.model.comments_critieria_four_one"
      >
      </textarea>
                  </base-input>
                </td>
                <td></td>
              </tr>

              <tr>
                <td colspan="5">
                  <h5 class="card-title font-weight-bold">{{$t('medium_grant_ev.technical__criteria_5')}}</h5>
                  <p class="white-space-pre-line">
                    {{$t('medium_grant_ev.technical__criteria_5_sub')}}
                  </p>
                </td>
              </tr>

              <tr>
                <td>
                  <p class="white-space-pre-line">
                    {{$t('medium_grant_ev.technical__criteria_5_1')}}
                  </p>
                </td>
                <td>
                  {{$t('medium_grant_ev.technical__criteria_5_1_max')}}
                </td>
                <td>
                  <el-select class="filter-select mr-2" v-model="EvaluationForm.model.criteria_five_one" placeholder="Score">
                    <el-option v-for="item in 6" :key="item-1" :label="item-1" :value="item-1"/>
                  </el-select>
                </td>
                <td>
                  <base-input>
      <textarea
        class="form-control mt-5"
        :placeholder="$t('general.write_here')"
        v-model="EvaluationForm.model.comments_critieria_five_one"
      >
      </textarea>
                  </base-input>
                </td>
                <td></td>
              </tr>



            </table>
          </div>
        </div>


      </div>
    </div>
  </form>
</template>
<script>
  import {EvaluationForm} from "@/services";
  import InfoRight from './InfoRight';
  import ApplicationInfo from '../ApplicationInfo';
  import {CommentBox} from 'src/components';
  import {Select, Option} from 'element-ui';

  export default {
    components: {
      ApplicationInfo,
      InfoRight,
      CommentBox,
      [Select.name]: Select,
      [Option.name]: Option,
    },
    data() {
      return {
        EvaluationForm
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      }
    }
  }
</script>
<style scoped>
  textarea {
    resize: vertical !important;
  }
</style>